/* import __COLOCATED_TEMPLATE__ from './where-to-start.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    reportState: $TSFixMe;
    shouldShowPersonalized: boolean;
    selectedIndustryText: string;
    selectedIndustry: string;
    setUpFinClick: (section: string) => void;
  };
}

const WhereToStart = templateOnlyComponent<Signature>();
export default WhereToStart;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::WhereToStart': typeof WhereToStart;
  }
}
